import { render, staticRenderFns } from "./RouterTeamEditComponent.vue?vue&type=template&id=2523185b&scoped=true"
import script from "./RouterTeamEditComponent.vue?vue&type=script&lang=js"
export * from "./RouterTeamEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2523185b",
  null
  
)

export default component.exports